<template>
  <v-dialog
    width="500"
    v-model="changePasswordShow"
    persistent
  >
    <v-card class="pa-0">
      <v-card-text>
        <v-form ref="form">
          <v-text-field
            label="新密码"
            name="password"
            prepend-icon="mdi-lock-question"
            type="password"
            v-model="password"
            :rules="password_rules"
          ></v-text-field>

          <v-text-field
            id="identity"
            label="确认密码"
            name="repeat_password"
            prepend-icon="mdi-lock-question"
            type="password"
            v-model="repeat_password"
            :rules="password_rules"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="green darken-1" text @click="close">取消</v-btn>
        <v-btn color="primary" @click="save">
          确认
          <v-progress-circular
            v-if="pendingConfirm"
            indeterminate
            color="red"
            size="20"
          ></v-progress-circular>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data: () => ({
    password: '',
    repeat_password: '',
    password_rules: [
      value => !!value || '必填.',
      value => value.length >= 8 || '密码长度至少8位',
      value => /[a-zA-Z]/.test(value) || '密码必须包含字母',
      value => /[0-9]/.test(value) || '密码必须包含数字',
      value => /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value) || '密码必须包含特殊字符'
    ]
  }),
  computed: {
    ...mapGetters([
      'pendingConfirm',
      'changePasswordShow',
    ])
  },
  methods: {
    ...mapActions([
      'updatePassword',
      'alert'
    ]),
    save() {
      if (this.repeat_password === this.password) {
        this.updatePassword(this.password);
      } else {
        this.alert({ message: '两次输入的密码不一致', color: 'error' });
      }
    },
    close() {
      this.$store.commit('setChangePasswordShow', !this.changePasswordShow);
    }
  }
}
</script>
